import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth-store';

export const useAuth = (requireAuth: boolean = true) => {
  const { user, token } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (requireAuth && !token) {
      navigate('/auth');
    } else if (!requireAuth && token) {
      navigate('/dashboard');
    }
  }, [token, navigate, requireAuth]);

  return { user, token };
};